import { styled } from '../jss-style';
import gridStyle from './grid';

const useGridStyle = styled(gridStyle, 'grid');

export { gridStyle, useGridStyle };
export default gridStyle;